// hooks/useErrorBoundary.js
import { useState, useCallback } from 'react';

export const useErrorBoundary = () => {
  const [error, setError] = useState(null);
  const [errorInfo, setErrorInfo] = useState(null);

  const resetError = useCallback(() => {
    setError(null);
    setErrorInfo(null);
  }, []);

  const setErrorWithInfo = useCallback((error, errorInfo = null) => {
    setError(error);
    setErrorInfo(errorInfo);
    console.error('Error caught:', error, errorInfo);
  }, []);

  return {
    error,
    errorInfo,
    hasError: !!error,
    resetError,
    setErrorWithInfo
  };
};